export default (beginTime, endTime, dataFrequency, dataList, getDefaultData, isEqEndTime) => {
  let interval = (endTime.getTime() - beginTime.getTime()) / (6e4 * dataFrequency) + isEqEndTime
  let start = new Date(beginTime)
  let dataMap = dataList.reduce((map, data) => {
    let dataTime = new Date(data.dataTime)
    let minute = dataTime.getMinutes()
    dataTime.setMinutes(minute - (minute % 5), 0)
    map[dataTime.getTime()] = data
    return map
  }, {})
  let newDataList = []

  for (let i = 0; i < interval; i++) {
    newDataList.push(dataMap[start.getTime()] || getDefaultData(start.format('YYYY/MM/DD HH:mm:ss')))
    start.setMinutes(start.getMinutes() + dataFrequency)
  }

  return newDataList
}



// WEBPACK FOOTER //
// ./src/components/Data/ChartWrapper/completeData.js